export enum TicketStatus {
  OPEN = 'open',
  IN_PROGRESS = 'in_progress',
  WAITING = 'waiting',
  RESOLVED = 'resolved',
  CLOSED = 'closed',
  CANCELLED = 'cancelled',
}

export enum TicketPriority {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  CRITICAL = 'critical',
}

export enum TicketCategory {
  BUG = 'bug',
  FEATURE = 'feature',
  ADJUSTMENT = 'adjustment',
  QUESTION = 'question',
  OTHER = 'other',
}

export const TicketStatusLabels: { [key in TicketStatus]: string } = {
  [TicketStatus.OPEN]: 'Aberto',
  [TicketStatus.IN_PROGRESS]: 'Em andamento',
  [TicketStatus.WAITING]: 'Aguardando retorno',
  [TicketStatus.RESOLVED]: 'Resolvido',
  [TicketStatus.CLOSED]: 'Fechado',
  [TicketStatus.CANCELLED]: 'Cancelado',
};

export const TicketPriorityLabels: { [key in TicketPriority]: string } = {
  [TicketPriority.LOW]: 'Baixa',
  [TicketPriority.MEDIUM]: 'Média',
  [TicketPriority.HIGH]: 'Alta',
  [TicketPriority.CRITICAL]: 'Crítica',
};

export const TicketCategoryLabels: { [key in TicketCategory]: string } = {
  [TicketCategory.BUG]: 'Bug',
  [TicketCategory.FEATURE]: 'Nova feature',
  [TicketCategory.ADJUSTMENT]: 'Ajuste',
  [TicketCategory.QUESTION]: 'Dúvida',
  [TicketCategory.OTHER]: 'Outro',
};

export interface TicketFile {
  _id: string;
  originalname: string;
  mimetype: string;
  path: string;
  size: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface TicketComment {
  author: string;
  author_id: string;
  message: string;
  fromAdmin: boolean;
  createdAt: Date;
}

export interface TicketRequester {
  name: string;
  email: string;
}

export interface Ticket {
  _id: string;
  title: string;
  description: string;
  recordNumbers: number[];
  status: TicketStatus;
  priority: TicketPriority;
  category: TicketCategory;
  dueDate?: Date;
  requesters: TicketRequester[];
  author: string;
  author_id: string;
  assignee?: string;
  files: TicketFile[];
  comments: TicketComment[];
  resolvedAt?: Date;
  completedAt?: Date;
  hoursSpent?: number;
  createdAt: Date;
  updatedAt: Date;
  __v?: number;
}
